import { Injectable } from '@angular/core';
import jwtDecode from 'jwt-decode';
import { CalendarUser } from 'src/app/components/my-calendar/day-view-scheduler.component';
import { Agency } from 'src/app/domain/agency';
import { User } from 'src/app/domain/user';
import { Permissions } from 'src/app/domain/user-profile/permissions';
import { Role } from 'src/app/domain/user-profile/role';
import { environment } from 'src/environments/environment';

@Injectable()
export class CoreData {
    private REFRESH_TOKEN = `${environment.appCode}_REFRESH_TOKEN_` + environment.name;
    private TOKEN = `${environment.appCode}_TOKEN_` + environment.name;
    private WITH_OAUTH = `${environment.appCode}_WITH_OAUTH_` + environment.name;
    private ROLE_AND_PERMISSIONS = `${environment.appCode}_ROLE_AND_PERMISSIONS`;
    private SCOPE = `${environment.appCode}_SCOPE`;
    private SAMPLER_LIST = `${environment.appCode}_SAMPLER_LIST`;
    private AGENCY = `${environment.appCode}_AGENCY`;
    private CALENDAR_DATE = `${environment.appCode}_CALENDAR_DATE`;
    private SORT_TYPE = `${environment.appCode}_SORT_TYPE`;
    private SEGMENT_SIZE = `${environment.appCode}_SEGMENT_SIZE`;

    getUserFromJWTToken() {
        if (!this.Token)
            return;
        const u = new User();
        const decodedToken = jwtDecode(this.Token) as any
        u.Email = decodedToken.email;
        u.FirstName = decodedToken.given_name;
        u.LastName = decodedToken.display_name.split(' ')[1];
        u.Puid = decodedToken.upn.split('@')[0];
        return u;
    }

    get User(): User | undefined {
        return this.getUserFromJWTToken() ?? undefined;
    }

    set Token(token: string | null) {
        if (token)
            localStorage.setItem(this.TOKEN, token);
    }

    get Token() {
        return localStorage.getItem(this.TOKEN);
    }

    get RefreshToken() {
        return localStorage.getItem(this.REFRESH_TOKEN) as string;
    }

    get SelectedScopeCode() {
        return localStorage.getItem(this.SCOPE)!;
    }

    set SelectedScopeCode(scope: string) {
        localStorage.setItem(this.SCOPE, scope);
    }

    set RefreshToken(token: string) {
        localStorage.setItem(this.REFRESH_TOKEN, token);
    }

    get RoleAndPermissions() {
        if (localStorage.getItem(this.ROLE_AND_PERMISSIONS)) {
            return JSON.parse(atob(localStorage.getItem(this.ROLE_AND_PERMISSIONS)!));
        }
        return new Role;
    }

    set RoleAndPermissions(ui: Role) {
        if (ui) {
            localStorage.setItem(this.ROLE_AND_PERMISSIONS, btoa(JSON.stringify(ui)));
        } else {
            localStorage.removeItem(this.ROLE_AND_PERMISSIONS);
        }
    }

    get SamplerList() {
        if (localStorage.getItem(this.SAMPLER_LIST)) {
            return JSON.parse(atob(localStorage.getItem(this.SAMPLER_LIST)!));
        }
        return [];
    }

    set SamplerList(ui: CalendarUser[]) {
        if (ui) {
            localStorage.setItem(this.SAMPLER_LIST, btoa(JSON.stringify(ui)));
        } else {
            localStorage.removeItem(this.SAMPLER_LIST);
        }
    }

    get Agency() {
        if (localStorage.getItem(this.AGENCY)) {
            return JSON.parse(atob(localStorage.getItem(this.AGENCY)!));
        }
        return undefined;
    }

    set Agency(agency: Agency | undefined) {
        localStorage.setItem(this.AGENCY, btoa(JSON.stringify(agency)));
    }

    get CalendarDate() {
        if (localStorage.getItem(this.CALENDAR_DATE)) {
            return new Date(JSON.parse(localStorage.getItem(this.CALENDAR_DATE)!));
        }
        return undefined;
    }

    set CalendarDate(date: Date | undefined) {
        localStorage.setItem(this.CALENDAR_DATE, JSON.stringify(date));
    }

    get SortType() {
        if (localStorage.getItem(this.SORT_TYPE)) {
            return JSON.parse(localStorage.getItem(this.SORT_TYPE)!);
        }
        return undefined;
    }

    set SortType(date: string | undefined) {
        localStorage.setItem(this.SORT_TYPE, JSON.stringify(date));
    }

    get SegmentSize() {
        if (localStorage.getItem(this.SEGMENT_SIZE)) {
            return Number(localStorage.getItem(this.SEGMENT_SIZE)!);
        }
        return 4;
    }

    set SegmentSize(size: number) {
        localStorage.setItem(this.SEGMENT_SIZE, `${size}`!);
    }

    get IsMobile() {
        return window.innerWidth < 960;
    }

    public get IsLoggedIn() {
        return this.Token && this.Token !== '' || false;

    }
    clearToken(): void {
        localStorage.removeItem(this.TOKEN);
    }
}
